export default "__VITE_ASSET__zCVo_Dd7__"